import { atom } from 'recoil'
import { IEquipmentGroup } from '../equipmentGroup.types.ts'

interface IEquipmentGroupsState {
  items: IEquipmentGroup[]
  loaded: boolean
}

const equipmentGroupsAtom = atom<IEquipmentGroupsState>({
  key: 'equipmentGroups',
  default: {
    items: [],
    loaded: false,
  },
})

export default equipmentGroupsAtom
